import {GAME_TABLE_MARGIN_PX} from '@constant/game';
import {TABLE_AREA_Z_INDEX} from '@constant/system';

const rectButtonHeight = 28;
const upperControlPanelHeight = 50;

const desktop = theme => {
  const {toVW} = theme;
  return {
    multipleGameRoomsContainer: {
      position: 'relative',
      overflowX: 'hidden',
      overflowY: 'hidden',
      height: '100vh',
      // background: theme.gameRoomStyles.gameRoomBackground,
      // backgroundImage: 'undefine',
      // backgroundColor: 'unset',
    },
    upperControlPanel: {
      height: 'fit-content',
    },
    // TODO scaling feature for upper section
    iconColumnContainer: {},
    centerPanel: {
      height: '3vw',
      alignItems: 'center',
      marginTop: 0,
      '& > *': {
        marginBottom: 0,
      },
    },
    newSquareButton: {
      width: '3vw',
      height: '3vw',
    },
    iconInSquareButton: {
      width: '1.6vw',
      height: '1.6vw',
    },
    mutedIcon: {
      width: '1.6vw',
      height: '1.6vw',
    },
    plusIcon: {
      width: '1.3vw',
      height: '1.3vw',
    },
    currentPotBox: {
      height: '2.5vw',
      fontSize: '1.25vw',
      paddingLeft: 20,
      paddingRight: 20,
      borderRadius: '1vw',
    },
    pingTimer: {
      top: 60,
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    multipleGameRoomsContainer: {
      width: '100%',
      height: '100vh',
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column',
      // alignItems: 'center',
      // justifyContent: 'center',
      // backgroundSize: 'auto',
      backgroundColor: theme.gameRoomBackground,
      // backgroundImage: 'url(images-mobile/game-room/game-room-background-upper-section.webp)',
      backgroundRepeat: 'repeat-x',
      backgroundPosition: 'top',
    },
    spinWrapper: {
      position: 'absolute',
      // top: -10,
      width: '100%',
      height: '100%',
      '& > .ant-spin-container.ant-spin-blur': {
        backgroundColor: '#212121',
        opacity: '0.1',
      },
      '& .ant-spin-text': {
        textShadow: 'none !important',
      },
      '& .ant-spin': {
        top: '50% !important',
        transform: 'translateY(-50%)',
      },
    },
    upperControlPanel: {
      width: '100%',
      height: upperControlPanelHeight,
      padding: '10px',
      position: 'relative',
      zIndex: TABLE_AREA_Z_INDEX.UPPER_CONTROL_BUTTONS,
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },
    iconColumnContainer: {
      display: 'flex',
      alignItems: 'flex-start', // TODO remove it later
      flexDirection: 'column',
      '& > button:not(:last-child)': {
        marginBottom: 15,
      },
    },
    iconRowContainer: {
      display: 'flex',
      flexDirection: 'row',
      '& > button:not(:last-child)': {
        marginRight: 4,
      },
      '@media (max-width: 350px)': {
        flexDirection: 'column',
        gap: 5,
      },
    },
    buttonContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
    },
    tableInActionIndicator: {
      position: 'absolute',
      borderRadius: 25,
      background: 'red',
      width: 5,
      height: 5,
      zIndex: 2,
      top: '-8px',
    },
    topButton: {
      border: 'none',
      color: theme.textColor,
      fontSize: 11,
      lineHeight: '11px',
      textAlign: 'center',
      background: 'rgba(0, 0, 0, 0.25)',
      boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
      borderRadius: '10px',
      height: '30px',
      '&.ant-btn:hover, &.ant-btn:focus, &.ant-btn:active': {
        backgroundColor: '#2E2534',
        border: '1px solid #6c6ad9',
        color: theme.textColor,
      },
    },
    squareButton: {
      extend: 'topButton',
      width: '30px',
      height: '30px',
      // display: 'flex',
      // justifyContent: 'center',
      // alignItems: 'center',
    },
    newSquareButton: {
      width: 30,
      height: 30,
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
      borderRadius: 10,
      border: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.textColor,
      '& img': {
        width: 18,
        height: 18,
      },
      '&.ant-btn': {
        padding: 0,
      },
      '&.ant-btn:hover, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), rgba(0, 0, 0, 0.25)',
        boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
        border: 'none',
        color: theme.textColor,
      },
    },
    plusButton: {
      extend: 'newSquareButton',
      '& img': {
        width: 12,
        height: 12,
      },
    },
    iconInSquareButton: {
      width: '16px',
      height: '16px',
    },
    plusIcon: {
      width: '16px',
      height: '16px',
    },
    centerPanel: {
      display: 'flex',
      flexWrap: 'wrap',
      // justifyContent: 'space-between',
      width: '100%',
      '& > *': {
        marginLeft: 4,
        marginRight: 4,
      },
    },
    leaveGameMenu: {
      whiteSpace: 'nowrap',
      padding: 0,
      background: 'transparent',
      '& > li': {
        color: theme.textColor,
        borderRadius: '10px',
        '&:not(:last-child)': {
          marginBottom: 5,
        },
      },
      '& .ant-dropdown-menu-item': {
        '&:hover': {backgroundColor: '#55555C'},
        fontSize: '12px',
      },
      '& .ant-dropdown-menu-item-icon': {
        fontSize: '16px',
      },
    },
    leaveGameMenuItem: {
      // backgroundColor: '#AE3f41',
      background:
        'linear-gradient(0deg, rgba(255, 0, 0, 0.5), rgba(255, 0, 0, 0.5)), rgba(0, 0, 0, 0.25)',
      extend: 'leaveTableMenuItem',
    },
    leaveTableMenuItem: {
      background:
        // eslint-disable-next-line max-len
        ' linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), rgba(0, 0, 0, 0.25)',
      boxShadow: 'inset 0px 1px 4px 1px rgba(255, 255, 255, 0.4)',
      backdropFilter: 'blur(12.5px)',
      borderRadius: '10px',
    },
    hidden: {
      display: 'none',
    },
    rectangularButton: {
      extend: 'topButton',
      width: '15vw',
      paddingLeft: 13,
      paddingRight: 13,
      '&.highlighted': {
        border: '2px white solid',
      },
      '&.hasAlert': {
        '&::after': {
          content: '""',
          backgroundImage: 'url(/icon/menu/alert.svg)',
          backgroundSize: '20px 20px',
          backgroundRepeat: 'no-repeat',
          position: 'absolute',
          left: 0,
          top: -6,
          width: 20,
          height: 20,
        },
      },
    },
    currentPotBox: {
      extend: 'rectangularButton',
      backgroundColor: 'none',
      '&.ant-btn:hover, &.ant-btn:focus, &.ant-btn:active': {
        background:
          'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), rgba(0, 0, 0, 0.25)',
        border: '1px solid white',
        color: theme.textColor,
      },
    },
    currentTableIndicator: {
      extend: 'rectangularButton',
      border: '2px white solid',
    },
    rectangularButtonAsDiv: {
      extend: 'rectangularButton',
      lineHeight: `${rectButtonHeight}px`,
      '& .ant-statistic': {
        lineHeight: 'inherit',
      },
    },
    hidden: {
      display: 'none',
    },
    mutedIcon: {
      height: '16px',
    },
    tablesContainer: {
      width: `calc(400vw + ${2 * 4 * GAME_TABLE_MARGIN_PX}px)`,
      display: 'flex',
      flexDirection: 'row',
      position: 'relative',
      zIndex: TABLE_AREA_Z_INDEX.TABLE_SECTION,
      top: -upperControlPanelHeight,
      margin: 'auto',
    },
    pingTimer: {
      position: 'absolute',
      top: 45,
      left: 10,
    },
    baseAmount: {
      width: '54px',
      height: '28px',
      fontSize: '16px',
    },
    modalTitle: {
      display: 'block',
      fontSize: '14px',
      textAlign: 'center',
      paddingTop: 15,
    },
    modalImageDiv: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 10,
      minHeight: '87px',
    },
    modalContent: {
      extend: 'modalTitle',
      color: '#D5D5D5',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
